import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Redirect extends Vue {

	redirectTo(name: string, params?: any, query?: any) {
		this.$router.push({ name, params, query }).catch(err => {
			if (err.name !== 'NavigationDuplicated') console.warn(err);
		});
	}

}
